import { useEffect, useState, createContext } from 'react';

const DataContext = createContext({
  navData:{}
});

function DataContextProvider({ children }) {
    const [navData, setNavData] = useState();

    useEffect(() => {
      async function getData() {
        const dataUrl = "https://courageous-sponsorcontent-cdn.s3.us-east-1.amazonaws.com/sponsorcontent/footer/navData.json";
        try {
          const response = await fetch(dataUrl);
          if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
          }
      
          const json = await response.json();
          setNavData(json);
        } catch (error) {
          console.error(error.message);
        }
      }
     getData();
     }, []);
  return (
    <DataContext.Provider value={{ navData }}>{children}</DataContext.Provider>
  );
}

export { DataContext, DataContextProvider };
